<template>
  <div class="hp">
    <!-- banner图 -->
    <div class="top_banner_box" ref="yanse">
      <div class="banner" id="anchor0" style="width: 100%">
        <el-carousel :height="height" v-if="slideshow && slideshow.length > 0">
          <el-carousel-item v-for="item in slideshow" :key="item.index">
            <a :href="item.path"><img :src="item.img" alt="" class="images" /></a>
          </el-carousel-item>
        </el-carousel>
        <div class="banner_image" v-else>
            <img src="../assets/img/banner1@2x.png" alt="" />
          <a href="javascript:;" @click="$store.commit('PageIds', true)">
            <img src="../assets/img/homeBanner@2x.png" alt="" />
          </a>
        </div>
      </div>
      <!-- 1440px图片 -->
      <!-- <div class="banner_box">
        <div class="banner_div">
          <p class="title">专注农批市场数字化运营管理平台</p>
          <div>
            <div class="small-title">
              <p>有用</p>
              <div>实现市场数字化管理，提升管理能力，降本增效</div>
            </div>
            <div class="small-title">
              <p>易用</p>
              <div>针对运营管理场景设计，融合多种智能设备</div>
            </div>
            <div class="small-title">
              <p>好用</p>
              <div>SaaS化平台架构，稳定、可靠、免维护</div>
            </div>
          </div>
          <a href="javascript:;"  @click="probation()">免费试用</a>
        </div>
      </div>
      <div class="tupian">
        <img src="../assets/img/banner1@2x.png" alt="" />
      </div> -->

      <!-- 轮播 -->
      <!-- <el-carousel
        :interval="5000"
        arrow="never"
        :autoplay="false"
        trigger="click"
        height="600px"
        ref="banner"
      >
        <el-carousel-item
          v-for="(item, index) in banners"
          :key="index"
          :label="'0' + (index + 1)"
        >
          <div class="banner_box">
            <div class="banner_div" v-if="index == 0">
              <p>{{ item.text }}</p>
             <a href="javascript:;" >免费试用</a>
            </div>
            <div v-else-if="index == 4" class="poa">
              <div class="name">{{ item.name }}</div>
              <div class="more" style="margin: 26px auto">了 解 更 多</div>
            </div>
            <div v-else class="pos">
              <div class="names">{{ item.p1 }}</div>
              <h1>{{ item.name }}</h1>
              <div class="names" style="font-size: 12px">{{ item.p2 }}</div>
              <div class="more" style="margin-top: 24px; margin-left: 0">
                了 解 更 多
              </div>
            </div>
          </div>


          <el-image :src="item.url" fit="fill"> </el-image>
        </el-carousel-item>
      </el-carousel>
      <div class="banner_box">
        <div class="prev" @click="prev">
          <img src="../assets/img/left@2x.png" />
        </div>
        <div class="next" @click="next">
          <img src="../assets/img/right@2x.png" />
        </div>
      </div> -->
    </div>
    <!-- 产品架构导览 -->
    <!-- <div class="centre architecture_box">
      <a href="javascript:;">
        <div class="agricultural_head trial">
          <p>产品架构导览<img class="img1" src="../assets/img/title3@2x.png" alt=""/></p>
          <div></div>
        </div>
        <div class="nongpi_box" v-show="architecture == 1">
          <div class="left_box">
            <div class="architecture_active_title">农批市场管理平台</div>
            <div class="architecture_active_content">一站式综合管理平台,满足不同岗位市场管理人员业务需求, 移动办公便捷高效。</div>
            <div class="architecture_active_detail" @click="toPage(1)">了解详情 <img src="../assets/img/zhankai.png" alt=""></div>
          </div>
          <div class="center_boxs architecture_con" @mouseenter="mouseoverNongmao">
            农<br>贸<br>市<br>场<br>管<br>理<br>平<br>台
          </div>
          <div class="right_box architecture_con" @mouseenter="mouseoverWuliu">
            物<br>流<br>园<br>区<br>管<br>理<br>平<br>台
          </div>
        </div>
        <div class="nongpi_box" v-show="architecture == 2">
          <div class="center_boxs1 architecture_con" @mouseenter="mouseoverNongpi">
            农<br>批<br>市<br>场<br>管<br>理<br>平<br>台
          </div>
          <div class="left_box left_box1">
            <div class="architecture_active_title">农贸市场管理平台</div>
            <div class="architecture_active_content">数智化运营赋能农贸市场, 完善食安追溯体系, 实现全流程数字化管理, 帮助市场转型升级, 降本增效。</div>
            <div class="architecture_active_detail" @click="toPage(2)">了解详情 <img src="../assets/img/zhankai.png" alt=""></div>
          </div>
          <div class="right_box architecture_con" @mouseenter="mouseoverWuliu">
            物<br>流<br>园<br>区<br>管<br>理<br>平<br>台
          </div>
        </div>
        <div class="nongpi_box" v-show="architecture == 3">
          <div class="center_boxs1 architecture_con" @mouseenter="mouseoverNongpi">
            农<br>批<br>市<br>场<br>管<br>理<br>平<br>台
          </div>
          <div class="center_boxs architecture_con" @mouseenter="mouseoverNongmao">
            农<br>贸<br>市<br>场<br>管<br>理<br>平<br>台
          </div>
          <div class="left_box left_box2">
            <div class="architecture_active_title">物流园区管理平台</div>
            <div class="architecture_active_content">数智化运营赋能农贸市场, 完善食安追溯体系, 实现全流程数字化管理, 帮助市场转型升级, 降本增效。</div>
            <div class="architecture_active_detail" @click="toPage(3)">了解详情 <img src="../assets/img/zhankai.png" alt=""></div>
          </div>
        </div>
      </a>
    </div> -->
    <!-- 系统应用场景 -->
    <div class="system_apply">
      <div class="centre">
        <!-- <a href="javascript:;"> -->
        <div class="agricultural_head trial">
          <p>
            系统应用场景
            <img src="../assets/img/title3@2x.png" alt="" />
          </p>
          <div></div>
        </div>
        <div class="center_box" id="anchor1">
          <div
            v-for="(item, index) in systemApplyList"
            :key="index"
            @mouseenter="move(index)"
            @mouseleave="Removed(index)"
            class="system apply"
          >
            <img :src="item.url" alt="" />
            <div class="systembox">
              <div class="systembox_title">
                {{ item.p1 }}
              </div>
            </div>
          </div>
        </div>
        <!-- </a> -->
      </div>
    </div>
    <!-- 产品体系 -->
    <div class="system_box">
      <div class="centre">
        <!-- <a href="javascript:;"> -->
        <div class="agricultural_head trial">
          <p>
            产品体系
            <img src="../assets/img/title3@2x.png" alt="" />
          </p>
          <div></div>
        </div>
        <div class="center_box" id="anchor1">
          <div
            v-for="(item, index) in systemList"
            :key="index"
            @mouseenter="move(index)"
            @mouseleave="Removed(index)"
            class="system"
          >
            <div v-if="item.p1 != '了解更多'">
              <img :src="item.url" alt="" />
              <div class="systembox">
                <div class="systembox_title">
                  {{ item.p1 }}
                </div>
                <div class="systembox_center">
                  <p>{{ item.p2 }}</p>
                  <p>{{ item.p3 }}</p>
                </div>
              </div>
            </div>
            <div v-else class="systembox_title systembox_nore" @click="toPage(4)" style="cursor: pointer;">了解更多>></div>
          </div>
        </div>
        <!-- </a> -->
      </div>
    </div>
    <!-- 我们的优势 -->
    <div class="advantage">
      <div class="agricultural_head trial" style="width: 1200px">
        <p style="color: #333333">
          我们的优势
          <img class="advantage_title-img" src="../assets/img/title3@2x.png" alt="" />
        </p>
        <div style="background: #333333"></div>
      </div>

      <div class="advantage_particulars">
        <div class="advantage_particulars_left">
          <img src="../assets/img/youshi.png" alt="" />
        </div>
        <div class="advantage_particulars_right">
          <ul>
            <li style="height: 102px">
              <img style="margin-top: 23px; margin-bottom: 0px" src="../assets/img/zhuanye@2x.png" alt="" />
              <div>
                <i>专业</i>
                <p style="margin-top: 8px">多年批发行业管理经验, 更了解行业需求</p>
              </div>
            </li>
            <li>
              <img src="../assets/img/shengxin@2x.png" alt="" />
              <div>
                <i>省心</i>
                <p>云平台部署，无需自建机房，专业团队统一运维管理，保障系统及数据安全可靠。</p>
              </div>
            </li>
            <li>
              <img src="../assets/img/xianjin@2x.png" alt="" />
              <div>
                <i>先进</i>
                <p>基于SaaS平台架构开发，业务功能持续免费更新迭代，长期使用无需升级</p>
              </div>
            </li>
            <li>
              <img src="../assets/img/wending@2x.png" alt="" />
              <div>
                <i>稳定</i>
                <p>系统根据等保3级要求建设部署，系统可用性大于99.99%，保障7*24小时不间断运行</p>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <!-- 移动应用 -->
    <!--    <div class="mobile">-->
    <!--      <div class="mobile_centre">-->
    <!--        <div class="agricultural_head trial">-->
    <!--          <p>移动应用<img src="../assets/img/title3@2x.png" alt=""/></p>-->
    <!--          <div></div>-->
    <!--        </div>-->
    <!--        <div class="mobile_centre_title">-->
    <!--          <div-->
    <!--              v-for="(item, index) in mobilelist"-->
    <!--              :key="index"-->
    <!--              @mouseenter="mobilemove(index)"-->
    <!--              @mouseleave="mobileRemoved(index)"-->
    <!--              :class="mobiles == index ? 'mobileboxs' : 'mobilebox'"-->
    <!--          >-->
    <!--            <div-->
    <!--                :class="mobiles == index ? 'mobilebox_rounds' : 'mobilebox_round'"-->
    <!--            >-->
    <!--              <img :src="item.url" alt="" class="mobilebox_round_img"/>-->
    <!--            </div>-->

    <!--            <div class="mobilebox1">-->
    <!--              <div class="mobilebox1_title">{{ item.p1 }}</div>-->
    <!--              <p>{{ item.p2 }}</p>-->
    <!--              <p>{{ item.p3 }}</p>-->
    <!--              <div class="mobilebox1_font">-->
    <!--                <a-->
    <!--                    href="javascript:;"-->
    <!--                    class="mobilebox1_fontb"-->
    <!--                    v-if="mobiles == index"-->
    <!--                >了解更多<img src="../assets/img/zhankai_lv1@2x.png" alt=""-->
    <!--                /></a>-->
    <!--                <a href="javascript:;" class="mobilebox1_fonta" v-else-->
    <!--                >了解更多<img src="../assets/img/zhankai_1@2x.png" alt=""-->
    <!--                /></a>-->
    <!--              </div>-->
    <!--            </div>-->
    <!--          </div>-->
    <!--        </div>-->
    <!--      </div>-->
    <!--    </div>-->
    <!-- 智能硬件对接 -->
    <!--    <div class="try">-->
    <!--      <div class="try_banner">-->
    <!--        <div class="agricultural_head trial" style="width: 1200px; z-index: 99">-->
    <!--          <p style="color: #ffffff">-->
    <!--            智能硬件对接<img-->
    <!--              class="try_title-img"-->
    <!--              src="../assets/img/title3@2x.png"-->
    <!--              alt=""-->
    <!--          />-->
    <!--          </p>-->
    <!--          <div style="background: #ffffff"></div>-->
    <!--        </div>-->
    <!--        <div class="try_center">-->
    <!--          <a href="javascript:;">-->
    <!--            <img src="../assets/img/yingjian_1@2x.png" alt=""/>-->
    <!--            <p>智能电子秤</p>-->
    <!--          </a>-->
    <!--          <a href="javascript:;">-->
    <!--            <img src="../assets/img/yingjian_2@2x.png" alt=""/>-->
    <!--            <p>智能移动终端</p>-->
    <!--          </a>-->
    <!--          <a href="javascript:;">-->
    <!--            <img src="../assets/img/yingjian_3@2x.png" alt=""/>-->
    <!--            <p>智能水电表</p>-->
    <!--          </a>-->
    <!--          <a href="javascript:;">-->
    <!--            <img src="../assets/img/yingjian_4@2x.png" alt=""/>-->
    <!--            <p>电子巡查</p>-->
    <!--          </a>-->
    <!--          <a href="javascript:;">-->
    <!--            <img src="../assets/img/yingjian_5@2x.png" alt=""/>-->
    <!--            <p>多媒体终端</p>-->
    <!--          </a>-->
    <!--          <a href="javascript:;">-->
    <!--            <img src="../assets/img/yingjian_6@2x.png" alt=""/>-->
    <!--            <p>智能监控</p>-->
    <!--          </a>-->
    <!--          <a href="javascript:;">-->
    <!--            <img src="../assets/img/yingjian_7@2x.png" alt=""/>-->
    <!--            <p>智能灯杆屏</p>-->
    <!--          </a>-->
    <!--          <a href="javascript:;">-->
    <!--            <img src="../assets/img/yingjian_8@2x.png" alt=""/>-->
    <!--            <p>停车场系统</p>-->
    <!--          </a>-->
    <!--        </div>-->
    <!--      </div>-->
    <!--    </div>-->

    <!-- 硬件设备 -->
    <!-- <div class="hardware" id="anchor2">
      <div class="hardware_banner">
        <div class="hardware_banner_head">
          <i>硬件设备</i>
          <div class="hardware_banner_cut"></div>
        </div>
        <div class="hardware_banner_foot">
          <div class="banner_foot_img Fixed">
            <img src="../assets/img/dibang@2x.png" alt="" />
          </div>
          <div class="banner_foot_text Fixed">
            <div class="foot_text">
              <i>无人值守地磅</i>
              <p>
                无人值守智能称重系统，将原来粗狂、繁杂的称重管理工作变得非常高效、简单、便捷，同时完全杜绝了各种称重作弊行为。
              </p>
            </div>
          </div>
          <div class="banner_foot_text Fixed">
            <div class="foot_text">
              <i>智能识别秤</i>
              <p>
                通过前端图像识别以及行业应用算法可以识别蔬菜、水果、肉类、干货类等农产品。识别速度小于1秒，识别准确率达95%以上，自动计算商品价格。
              </p>
            </div>
          </div>
          <div class="banner_foot_img Fixed">
            <img src="../assets/img/tu_cheng@2x.png" alt="" />
          </div>
          <div class="banner_foot_img Fixed">
            <img src="../assets/img/tu_cheng复制 3@2x.png" alt="" />
          </div>
          <div class="banner_foot_text Fixed">
            <div class="foot_text">
              <i>数据展示大屏</i>
              <p>
                数据展示大屏，通过市场运营平台采集相关信息，并集中进行处理，将市场的交易数据、供货车辆数据、产品检测公示、价格行情、资讯公示等内容，通过大屏以图表方式发布
              </p>
            </div>
          </div>
          <div class="banner_foot_text Fixed">
            <div class="foot_text">
              <i>移动手持</i>
              <p>
                商户进销存移动手持POS，具备商品管理、开单、收银、订单查询、优惠券核销等功能一体的移动终端设备。提升交易支付的用户体验，支持多种支付方式和平台。
              </p>
            </div>
          </div>
          <div class="banner_foot_img Fixed">
            <img src="../assets/img/pos@2x.png" alt="" />
          </div>
        </div>
      </div>
    </div> -->

    <!-- 客户案例 -->
    <!-- <div class="client" id="anchor3">
      <div class="client_banner">
        <div class="client_banner_head">
          <i>客户案例</i>
          <div class="banner_head_cut"></div>
        </div>
        <vue-seamless-scroll
          :data="clientList"
          :class-option="initOption"
          style="height: 288px; width: 1440px; overflow: hidden"
        >
          <div class="client_foot">
            <div
              class="client_foot_box"
              v-for="(item, index) in clientList"
              :key="index"
            >
              <img :src="item.url" alt="" />
              <div>{{ item.name }}</div>
            </div>
          </div>
        </vue-seamless-scroll>
      </div>
    </div> -->
    <!-- 合作伙伴 -->
    <div class="partner" id="anchor4">
      <div class="partner_banner">
        <div class="agricultural_head trial">
          <p style="color: #333333">
            合作伙伴
            <img src="../assets/img/title3@2x.png" alt="" />
          </p>
          <div style="background: #333333"></div>
        </div>
        <div class="partner_foot">
          <img :src="item" v-for="item in partnerList" :key="item.index" />
        </div>
      </div>
    </div>
    <!--  页脚链接  -->
    <!-- <footer-link></footer-link> -->
    <!-- 免费注册弹框 -->
    <div class="shade" v-if="seen">
      <div class="register">
        <div class="h">
          <p>免费试用</p>
          <img src="../assets//img/close@2x.png" @click="quxiao()" />
        </div>
        <div class="h_form">
          <el-form ref="ruleForm" :model="ruleForm" label-width="80px" :rules="rules">
            <div class="inp">
              <el-form-item prop="companyName">
                <img src="../assets//img/gongsi@2x.png" alt="" />
                <el-input v-model="ruleForm.companyName" placeholder="公司名称" style="border: 0"></el-input>
                <!-- <div class="inp_ch" >
                </div> -->
              </el-form-item>
            </div>

            <div class="inp">
              <el-form-item prop="linkman">
                <div class="inp_ch">
                  <img src="../assets//img/lianxiren@2x.png" alt="" />
                  <el-input v-model="ruleForm.linkman" placeholder="联系人"></el-input>
                </div>
              </el-form-item>
            </div>
            <div class="inp">
              <el-form-item prop="phone">
                <div class="inp_ch">
                  <img src="../assets//img/shoujill@2x.png" alt="" />
                  <el-input v-model="ruleForm.phone" placeholder="手机号码"></el-input>
                </div>
              </el-form-item>
            </div>
            <div class="inp">
              <el-form-item>
                <div class="inp_ch">
                  <img src="../assets//img/yanzheng@2x.png" alt="" />
                  <el-input v-model="ruleForm.messageCode" placeholder="验证码" class="yanzheng"></el-input>
                  <div class="vertical">|</div>
                  <div v-show="show" class="send" @click="getCode()">发送验证码</div>
                  <div v-show="!show" class="send_count">{{ count }}</div>
                </div>
              </el-form-item>
            </div>
          </el-form>
        </div>

        <div class="submit" @click="submit('ruleForm')">提交</div>
        <div class="register_font">
          <span>
            已有账号?
            <button>去登录</button>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import vueSeamlessScroll from 'vue-seamless-scroll'
import FooterLink from '@/components/footer/footerLink'

export default {
  components: {
    vueSeamlessScroll,
    FooterLink
  },
  data() {
    var checkMobile = (rule, value, callback) => {
      const regMobile = /^(0|86|17951)?(1[123456789]\d{9})$/
      if (regMobile.test(value)) {
        this.checkPhone = true
        return callback()
      }
      callback(new Error('请输入合法的手机号'))
    }

    return {
      checkPhone: false,
      // 导航
      // nav: ["首页", "解决方案", "硬件设备", "客户案例", "合作伙伴", "关于我们"],
      // 轮播图
      // banners: [
      //   {
      //     url: require("../assets/img/banner1@2x.png"),
      //     text: "致力打造智慧农贸信息化平台",
      //   },
      //   {
      //     url: require("../assets/img/banner2.png"),
      //     p1: "「E6」系列农产品识别集成模块",
      //     p2: "集成图像拍摄、边缘计算、数据通信等功能于一体，农产品识别速度小于1秒，识别准确率达95%以上",
      //     name: "农产品智能识别集成模组",
      //   },
      //   {
      //     url: require("../assets/img/banner3.png"),
      //     p1: "智能零售电子秤",
      //     p2: "达到国家标准要求的计量，防作弊以及智能实现集成农产品品类识别、数据采集、交易支付等功能",
      //     name: "智能零售紧跟发展趋势",
      //   },
      //   {
      //     url: require("../assets/img/banner4.png"),
      //     p1: "小程序，轻应用系统",
      //     p2: "以农产品流通云平台为基础的八大应用系统，覆盖政府监管、市场管理、销售管理、用户服务等各类业务需求",
      //     name: "智能管理系统连接线上线下",
      //   },
      //   {
      //     url: require("../assets/img/banner5.png"),
      //     name: "致力于打造智慧农贸信息化平台",
      //   },
      // ],

      // 产品体系
      systemList: [
        {
          url: require('../assets/img/chanpin_1@2x.png'),
          p1: '市场运营管理平台',
          p2: '全面数智化管理 切实解决管理难题',
          p3: '助力市场升级转型 降本增效'
        },
        {
          url: require('../assets/img/chanpin_4@2x.png'),
          p1: '商户进销存平台',
          p2: '适用于各种业务模式和交易流程',
          p3: '界面简洁 轻松上手 实时查看数据'
        },
        {
          url: require('../assets/img/chanpin_3@2x.png'),
          p1: '支付结算系统',
          p2: '一键扫码支付 支持多种支付方式',
          p3: '交易清晰可查 做账简单方便'
        },
        {
          url: require('../assets/img/chanpin_2@2x.png'),
          p1: '物联网(IoT)平台',
          p2: '融合多种硬件设备对接',
          p3: '一站式实现产品智能化'
        },
        {
          url: require('../assets/img/chanpin_6@2x.png'),
          p1: '电子会员系统',
          p2: '多功能高效转化流量 会员沉淀机制',
          p3: '助力精细客群管理 引流获客新加持'
        },
        {
          url: require('../assets/img/chanpin_5@2x.png'),
          p1: '线上商城系统',
          p2: '增加新赋能 提升高效率',
          p3: '一键下单 即刻享受配送到家'
        },
        {
          url: require('../assets/img/dibang.png'),
          p1: '无人值守地磅',
          p2: '提高效率降低成本 规范市场秩序',
          p3: '优化物流资源管控体系'
        },
        {
          url: '',
          p1: '了解更多',
          p2: '增加新赋能 提升高效率',
          p3: '一键下单 即刻享受配送到家'
        }
      ],
      // 系统应用场景
      systemApplyList: [
        {
          url: require('../assets/img/zixun_1@2x.png'),
          p1: '农产品产地市场'
        },
        {
          url: require('../assets/img/zixun_2@2x.png'),
          p1: '农产品批发市场'
        },
        {
          url: require('../assets/img/zixun_3@2x.png'),
          p1: '农贸市场'
        },
        {
          url: require('../assets/img/zixun_4@2x.png'),
          p1: '小商品市场'
        },
        {
          url: require('../assets/img/zixun_5@2x.png'),
          p1: '服装批发市场'
        },
        {
          url: require('../assets/img/zixun_6@2x.png'),
          p1: '五金批发市场'
        }
      ],
      //移动应用
      mobilelist: [
        {
          url: require('../assets/img/yd_1@2x.png'),
          p1: '市场运营管理App',
          p2: '一键轻松管理市场日常维护',
          p3: '简单高效省力 链接内外系统畅通无阻'
        },
        {
          url: require('../assets/img/yd_2@2x.png'),
          p1: '商户App',
          p2: '方便老板查看商铺多种数据 ',
          p3: '根据智能分析 调节经营方向'
        },
        {
          url: require('../assets/img/yd_3@2x.png'),
          p1: '合作商小程序',
          p2: '货主【货品登记】的单独管理平台',
          p3: '界面简洁明了  操作好用易上手'
        }
      ],
      // 客户案例
      // clientList: [
      //   {
      //     url: require("../assets/img/zixun_1@2x.png"),
      //     name: "宁波农副产品物流中心",
      //   },
      //   {
      //     url: require("../assets/img/zixun_2@2x.png"),
      //     name: "宁波水产品批发市场",
      //   },
      //   {
      //     url: require("../assets/img/zixun_3@2x.png"),
      //     name: "滨海农副产品批发市场",
      //   },
      //   {
      //     url: require("../assets/img/zixun_4@2x.png"),
      //     name: "安吉农副产品综合批发市场",
      //   },
      //   {
      //     url: require("../assets/img/zixun_5@2x.png"),
      //     name: "新乡农贸综合批发大市场",
      //   },
      // ],
      // 合作伙伴
      partnerList: [
        require('../assets/img/kehu_1@2x.png'),
        require('../assets/img/kehu_2@2x.png'),
        require('../assets/img/kehu_3@2x.png'),
        require('../assets/img/kehu_4@2x.png'),
        require('../assets/img/kehu_5@2x.png'),
        require('../assets/img/kehu_6@2x.png'),
        require('../assets/img/kehu_7@2x.png'),
        require('../assets/img/kehu_8@2x.png'),
        require('../assets/img/kehu_9@2x.png'),
        require('../assets/img/kehu_10@2x.png')
      ],

      current: 0,
      seen: false,
      // 试用表单

      ruleForm: {
        companyName: '',
        linkman: '',
        phone: '',
        messageCode: ''
      },
      rules: {
        companyName: [{ required: true, message: '请输入公司名称', trigger: 'blur' }],
        linkman: [{ required: true, message: '请输入联系人', trigger: 'blur' }],
        phone: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          {
            validator: checkMobile,
            trigger: 'blur'
          }
        ]
      },
      // 读秒
      show: true,
      count: '',
      timer: null,

      carousel: '',

      slideshow: [], //获取到的轮播数据
      ss: -1, //产品移入移出
      mobiles: -1, //移动应用记录移入移出
      windowHeight: document.documentElement.clientHeight,
      height: '',
      architecture: 1
    }
  },
  mounted() {
    window.onresize = () => {
      return (() => {
        console.log((window.screenHeight = document.body.clientHeight))
        this.heights()
      })()
    }

    // this.carousel = document.querySelector(".client_foot");
    // this.autoRun();

    console.log(this.height)
    this.height = parseInt(this.windowHeight * 0.82) + 'px'
    this.$axios
      .get('api/hopdata-core/rotationimg/list')
      .then(res => {
        if (res.data.code == 200) {
          this.slideshow = res.data.data
          // this.$refs.yanse.style.backgroundColor='red'
        }
      })
      .catch(err => {
        if (err) {
          console.log(1)
        }
      })
  },
  computed: {
    initOption() {
      return {
        step: 1, // 数值越大速度滚动越快
        limitMoveNum: 2, // 开始无缝滚动的数据量 this.dataList.length
        hoverStop: true, // 是否开启鼠标悬停stop
        direction: 2, // 0向下 1向上 2向左 3向右
        openWatch: true, // 开启数据实时监控刷新dom
        singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
        singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
        waitTime: 0 // 单步运动停止的时间(默认值1000ms)
      }
    }
  },
  methods: {
    heights() {
      this.height = parseInt(this.windowHeight * 0.77) + 'px'
    },
    //移动应用
    mobilemove(index) {
      this.mobiles = index
    },
    mobileRemoved(index) {
      this.mobiles = -1
    },
    //产品体系移入事件
    move(index) {
      this.ss = index
    },
    //产品移出事件
    Removed(index) {
      this.ss = -1
    },
    //
    // 导航锚点跳转
    goAnchor(selector, index) {
      this.current = index

      //         var anchor = this.$el.querySelector("#" + selector) // 参数为要跳转到的元素id
      //   document.body.scrollTop = anchor.offsetTop; // chrome
      //   document.documentElement.scrollTop = anchor.offsetTop;

      document.querySelector('#' + selector).scrollIntoView()
      let scrolledY = window.scrollY

      if (scrolledY) {
        window.scroll(0, scrolledY - 75)
      }
      // document.documentElement.scrollTop = (this.$refs.recommend.offsetTop - 80)
    },
    //上一张轮播
    prev() {
      this.$refs.banner.prev()
    },
    //下一张轮播
    next() {
      this.$refs.banner.next()
    },
    // 试用弹窗
    probation() {
      this.seen = true
      this.$store.commit('PageIds', true)
      // document
      //   .querySelector("body")
      //   .setAttribute("style", " overflow: hidden;");
      this.ruleForm = {
        companyName: '',
        linkman: '',
        phone: '',
        messageCode: ''
      }
      clearInterval(this.timer)
      this.timer = null
    },
    quxiao() {
      this.seen = false
      this.show = true

      // document.querySelector("body").setAttribute("style", " overflow: none;");
    },
    submit(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.$axios
            .post('api/hopdata-core/apply/save', this.ruleForm)
            .then(res => {
              console.log(res)
              if (res.data.code == 200) {
                this.$message({
                  message: '恭喜您，申请成功',
                  type: 'success'
                })
                this.seen = false
                this.show = true
              } else {
                console.log(res.msg)

                this.seen = false
              }
            })
            .catch(res => {
              this.$message.error(res.response.data.msg)
            })
        }
      })
      // document.querySelector("body").setAttribute("style", " overflow: none;");
    },
    // 发送验证
    getCode() {
      if (this.ruleForm.phone !== '' && this.checkPhone) {
        this.$axios
          .post('api/blade-resource/sms/endpoint/send-validate', {
            phone: this.ruleForm.phone
          })
          .then(res => {
            if (res.data.code == 200) {
              const TIME_COUNT = 60
              if (!this.timer) {
                // clearInterval(this.timer)
                this.count = TIME_COUNT
                this.show = false
                this.timer = setInterval(() => {
                  if (this.count > 0 && this.count <= TIME_COUNT) {
                    this.count--
                  } else {
                    this.show = true
                    clearInterval(this.timer)
                    this.timer = null
                  }
                }, 1000)
              }
            }
          })
          .catch(res => {
            this.$message.error(res.response.data.msg)
          })
      } else {
        this.$message({
          message: '请输入合法的手机号！',
          type: 'warning'
        })
      }
    },

    mouseoverNongpi() {
      this.architecture = 1
    },
    mouseoverNongmao() {
      this.architecture = 2
    },
    mouseoverWuliu() {
      this.architecture = 3
    },
    toPage(i) {
      if (i === 1) {
        this.$router.push('/SmartAgriculture')
      } else if (i === 2) {
        this.$router.push('/SmartTrade')
      } else if (i === 3) {
        this.$router.push('/SmartPark')
      } else if (i === 4) {
        this.$router.push('/systemPlatform')
      }
      this.$store.commit('Navigation', i)
    }
  }
}
</script>
<style scoped>
.hp {
  width: 100%;
  min-width: 1440px;
}

.hp .nav {
  min-width: 1440px;
}

/deep/ .el-carousel__indicators--horizontal {
  position: absolute;
  left: auto;
  right: 10px;
  bottom: 25px;
  text-align: right;
}

.lunbo {
  height: auto !important;
}

/* /deep/.el-carousel__container{
  height: 17% !important;
} */
.el-carousel__indicator--horizontal button {
  width: 8px;
  height: 8px;
  background: #ffffff;
  border-radius: 50%;
  opacity: 0.5;
}

.el-carousel__indicator--horizontal.is-active button {
  width: 24px;
  height: 8px;
  background: #ffffff;
  opacity: 0.5;
  border-radius: 10px;
}

/* 导航 */
/* .nav {
  height: 77px;
  width: 100%;
  position: fixed;
  left: 50%;
  top: 0;
  transform: translateX(-50%);

  z-index: 2;
  background-color: #ffffff;
}
.nav_banner {
  width: 1300px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
}
.nav_logo {
  background-image: url("../assets/img/logo.png");
  background-size: 100% 100%;

  width: 203px;
  height: 48px;
  margin-top: 15px;
  margin-bottom: 14px;
}

.nav_carousel {
  width: 545px;
  display: flex;
  justify-content: space-between;
}

.nav_carousel li {
  display: inline-block;
  height: 70px;
  line-height: 70px;
  margin-left: 32px;
  cursor: pointer;
}

.active {
  border-bottom: 2px solid;
  color: #11b690;
}
.nav_carousel li:hover {
  border-bottom: 2px solid;
  color: #11b690;
}

.nav_login {
  font-size: 1rem;
  width: 350px;
}
.nav_login div {
  display: inline-block;
}

.nav_login .iphone {
  margin-top: 1.75rem;
}
.nav_login .iphone img {
  width: 1.5rem;
  height: 1.5rem;
  vertical-align: middle;
}
.right_login button {
  margin-left: 16px;
  border: 0;
  background-color: rgba(241, 251, 249, 0.493);
}
.right_login a {
  display: inline-block;
  height: 36px;
  width: 88px;
  text-align: center;
  line-height: 36px;
  color: #11b690;
  border-radius: 4px;
  border: 1px solid #11b690;
}
.right_login .login a {
  background: #11b690;
  color: #ffffffff;
} */

/* banner图 */
/* .banner {
  width: 100%;
  height: 600px;
  轮播即注销
 background-image: url("../assets/img/banner1@2x.png");
   background-size: 100% 100%;
  background-repeat: no-repeat;
} */

/* #anchor0 {
  width: 100% !important;

} */
/* .banner img {
  width: 1440px;
  margin: 0 auto;
  vertical-align: bottom;
  -o-object-fit: cover;
  object-fit: cover;
}
.banner .tupian {
  width: 1440px;
  margin: 0 auto;
}

.banner_box {
  margin: 0 auto;
  width: 1200px;
  position: relative;
} */

/* 顶部轮播图 */
/* .poa {
  position: absolute;
  left: 50%;
  margin-top: 270px;
  margin-left: -250px;
  width: 490px;
  height: 49px;
  font-size: 35px;
  font-family: PingFangSC-Semibold, PingFang SC;

  color: rgba(51, 51, 51, 1);
  line-height: 49px;
  z-index: 999;
} */
/* .prev {
  width: 16px;
  height: 16px;
  position: absolute;
  bottom: 10px;
  z-index: 100;
  left: 35%;
  cursor: pointer;
}
.next {
  width: 16px;
  height: 16px;
  position: absolute;
  bottom: 10px;
  z-index: 100;
  right: 35%;
  cursor: pointer;
}
.more {
  width: 140px;
  height: 40px;
  font-size: 16px;
  font-weight: 400;
  line-height: 40px;
  background-color: #11b690;
  color: #ffffff;
  border-radius: 4px;
  letter-spacing: 5px;
  text-align: center;
  cursor: pointer;
}
.pos {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 99;
  margin-top: 178px;
}
.pos h1 {
  height: 49px;
  font-size: 35px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: rgba(255, 255, 255, 1);
  line-height: 49px;
  text-shadow: 0px 2px 4px rgba(0, 0, 0, 0.5);
}
.pos .names {
  width: 326px;
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(255, 255, 255, 0.8);
  line-height: 17px;
  text-shadow: 0px 2px 4px rgba(0, 0, 0, 0.5);
} */

/* 1440px 点击按钮与文字 */
/* .banner .banner_div {
  width: 600px;
  position: absolute;
  left: 0;
  top: 0;
  z-index: 1;
  margin-top: 220px;
}
.banner .banner_div .title {
  font-size: 2.2rem;
  margin-bottom: 26px;
  color: #11b690;
}
.small-title {
  display: flex;
}
.small-title p {
  width: 60px;
  height: 30px;
  background: #ffb300;
  margin-right: 12px;
  font-size: 20px;
  color: #ffffff;
  margin-bottom: 20px;
  text-align: center;
  line-height: 30px;
  border-radius: 4px;
}
.small-title div {
  height: 50px;
  line-height: 30px;
  color: #333;
  font-size: 20px;
  font-weight: 500;
}
.banner .banner_div a {
  display: block;
  width: 140px;
  height: 44px;
  font-size: 1rem;
  line-height: 44px;
  background: rgba(17, 182, 144, 0.06);
  color: #11b690;
  border-radius: 4px;
  letter-spacing: 5px;
  text-align: center;
  border: 1px solid #11b690;
  margin-top: 40px;
  margin-left: 150px;
}
.el-image {
  height: 600px;
} */
.top_banner_box {
  width: 100%;
  /* background-color: #ECF9F6; */
}

.banner {
  width: 100%;
  margin: 0 auto;
}

.images {
  width: 100%;
  height: inherit;
}

.el-carousel__arrow {
  width: 60px !important;
  height: 60px !important;
  font-size: 24px !important;
}

.el-carousel__arrow--left {
  left: 100px !important;
}

.el-carousel__arrow--right {
  right: 100px !important;
}

.banner_image {
  width: 100%;
  height: auto;
  position: relative;
}

.banner_image img:first-child {
  width: 100%;
  height: auto;
}

.banner_image img:last-child {
  position: absolute;
  width: 186px;
  height: auto;
  top: 76.32%;
  left: 18.75%;
}

/* 内容 */
.centre {
  width: 1200px;
  margin: 0 auto;
}

/* 产品体系 */
.center_box {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}

.center_box .apply {
  margin-top: 50px;
  text-align: center;
  width: 376px;
  height: 268px;
  background: #ffffff;
  box-shadow: 0px 2px 15px 5px rgba(0, 0, 0, 0.05);
  border-radius: 4px;
}

.center_box .apply img {
  width: 340px;
  height: 190px;
  margin: 18px 18px 12px;
}

.system {
  margin-top: 50px;
  width: 282px;
  height: 282px;
  background: #fff;
  text-align: center;
  box-shadow: 0px 2px 15px 0px rgba(0, 0, 0, 0.05);
  border-radius: 12px;
}

.system:hover {
  box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.05);
}

.system img {
  width: 160px;
  height: 116px;
  margin: 24px;
}
.system:nth-child(7) img{
  margin: 0;
  width:100%;
  height: 164px;
}

.systembox {
  width: 100%;
}

.systembox_title {
  font-size: 20px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #333333;
  line-height: 28px;
}

.systembox_title span {
  display: inline-block;
  text-align: center;
  width: 40px;
  height: 20px;
  background: #ffb300;
  border-radius: 4px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #ffffff;
  line-height: 20px;
  vertical-align: middle;
  margin-top: -5px;
}

.systembox_center {
  width: 100%;
  margin-top: 16px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #999999;
  line-height: 22px;
}

.systembox_nore {
  line-height: 282px;
}

.systembox_font {
  height: 20px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #999999;
  margin-top: 8px;
}

.systembox_fonta {
  height: 20px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #1958c4;
  margin-top: 8px;
}

.systembox_fonta img {
  width: 9px;
  height: 9px;
}

.systembox_font img {
  width: 9px;
  height: 9px;
}

/* 移动应用 */
.mobile {
  width: 100%;
  margin: 0 auto;
  height: 493px;
  background: #f7fbff;
  border-radius: 4px;
  margin-top: 60px;
}

.mobile_centre {
  width: 1200px;
  height: 493px;
  margin: 0 auto;
}

.mobile_centre_title {
  display: flex;
  justify-content: space-between;
}

.mobilebox {
  width: 384px;
  height: 222px;
  background: linear-gradient(136deg, #5f96f5 0%, #2b5db3 100%);
  box-shadow: 0px 2px 15px 0px rgba(0, 0, 0, 0.05);
  border-radius: 4px;
  margin-top: 100px;
  position: relative;
}

.mobileboxs {
  width: 384px;
  height: 222px;
  background: linear-gradient(138deg, #78f2cc 0%, #18b394 100%);
  box-shadow: 0px 2px 15px 0px rgba(0, 0, 0, 0.05);
  border-radius: 4px;
  margin-top: 100px;
  position: relative;
  /* transform: scale(1.05, 1.05); */
}

.mobilebox_round {
  width: 100px;
  height: 100px;
  background: linear-gradient(136deg, #5f96f5 0%, #2b5db3 100%);
  position: absolute;
  border-radius: 50%;
  top: -50px;
  left: 50%;
  margin-left: -50px;
}

.mobilebox_rounds {
  width: 100px;
  height: 100px;
  background: linear-gradient(136deg, #77f3c1 0%, #18b394 100%);
  position: absolute;
  border-radius: 50%;
  top: -50px;
  left: 50%;
  margin-left: -50px;
}

.mobilebox_round_img {
  width: 50px;
  height: 50px;
  margin-top: 25px;
  margin-left: 25px;
}

.mobilebox1 {
  width: 100%;
  height: 222px;
  text-align: center;
}

.mobilebox1 .mobilebox1_title {
  padding-top: 78px;
  font-size: 20px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #ffffff;
  line-height: 18px;
  margin-bottom: 16px;
}

.mobilebox1 p {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #ffffff;
  line-height: 20px;
}

.mobilebox1 img {
  width: 9px;
  height: 9px;
  margin-left: 4px;
}

.mobilebox1 .mobilebox1_font {
  width: 104px;
  height: 34px;
  border-radius: 17px;
  margin: 0 auto;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  line-height: 34px;
  margin-top: 16px;
}

.mobilebox1 .mobilebox1_fonta {
  display: block;
  width: 104px;
  height: 100%;
  color: #ffffff;

  border-radius: 17px;
  border: 1px solid #ffffff;
}

.mobilebox1 .mobilebox1_fontb {
  display: block;
  width: 104px;
  height: 100%;
  background: #ffffff;
  border-radius: 17px;
  border: 1px solid #ffffff;
  font-size: 14px;
  border: 1px solid #ffffff;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;

  color: #11b690;
}

/* 智慧农产品批发 */
.agricultural_head {
  text-align: center;
  padding-top: 60px;
  padding-bottom: 50px;
}

.agricultural_head p {
  font-size: 30px;
  font-weight: 600;
  color: #333333;
  position: relative;
  z-index: 9;
}

.agricultural_head i {
  font-size: 14px;
  font-weight: 600;
  color: #999999;
}

.agricultural_head div {
  width: 60px;
  height: 2px;
  background: #333333;
  margin: 16px auto;
  z-index: 99;
}

.agricultural_head img {
  width: 32px;
  height: 32px;
  position: absolute;
  top: -8px;
  left: 643px;
  z-index: -1;
}

.agricultural_head .img1 {
  left: 672px;
}

/* 试用 */

.try {
  height: 420px;
  width: 100%;
  margin: 0 auto;
  background-image: url('../assets/img/middle@2x.png');
  background-repeat: no-repeat;
  background-size: 100% 100%;
  color: #ffffff;
  /* padding-bottom: 64px; */
}

.try_banner {
  width: 1200px;

  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  position: relative;
}

.try_center {
  width: 1200px;
  height: 420px;
  display: flex;
  position: absolute;
  top: 0;
  left: 0;
}

.try_center a {
  display: block;
  width: 160px;
  height: 229px;
  /* background-color: red; */
  padding-top: 191px;
  text-align: center;
}

.try_center a:hover {
  height: 261px;

  padding-top: 159px;
  background: rgba(0, 0, 0, 0.5);
}

.try_center a img {
  width: 100px;
  height: 100px;
  /* margin: 0 auto; */
}

.try_center a p {
  margin-top: 55px;
  font-size: 20px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #ffffff;
  line-height: 28px;
}

.try_title-img {
  position: absolute;
  left: 670px !important;
}

/* 我们的优势 */
.advantage {
  width: 1200px;
  margin: 0 auto;
}

.advantage_title-img {
  left: 655px !important;
}

.advantage_particulars {
  margin-top: 30px;
  margin-bottom: 60px;
  display: flex;
  align-items: flex-end;
}

.advantage_particulars div {
  display: inline-block;
}

.advantage_particulars_left img {
  width: 560px;
  height: 441px;
  vertical-align: bottom;
  margin-left: 78px;
  margin-bottom: 40px;
}

.advantage_particulars_right {
  display: flex;
  justify-content: space-between;
}

.advantage_particulars_right li {
  width: 424px;
  height: 130px;
  background: #ffffff;
  box-shadow: 0px 2px 15px 0px rgba(0, 0, 0, 0.05);
  border-radius: 4px;
  padding-left: 24px;

  margin-left: 100px;
  margin-top: 20px;
  padding-right: 32px;
}

.advantage_particulars_right li:hover {
  transform: scale(1.05, 1.05);
  background: #e6f2ff;
  box-shadow: 0px 2px 15px 0px rgba(0, 0, 0, 0.05);
  border-radius: 4px;
}

.advantage_particulars_right i {
  font-size: 22px;
  font-weight: 600;
  color: #ff7308;
  line-height: 30px;
}

.advantage_particulars_right p {
  font-size: 14px;
  font-weight: 400;
  color: #333333;
  line-height: 28px;
  margin-top: 4px;
}

.advantage_particulars_right img {
  width: 56px;
  height: 56px;
  margin-right: 20px;
  margin-bottom: 10px;
}

.advantage_particulars_right div {
  width: 340px;
  margin-top: 20px;
}

/* 硬件设备 */
/* .hardware {
  width: 100%;
}
.hardware_banner {
  width: 1200px;
  padding-top: 60px;
  margin: 0 auto;
  text-align: center;
  margin-bottom: 60px;
}
.hardware_banner_head i {
  font-size: 30px;
  font-weight: 600;
  color: #333333;
}
.hardware_banner_cut {
  width: 60px;
  height: 2px;
  background: #333333;
  margin: 0 auto;
  margin-top: 30px;
  margin-bottom: 50px;
}
.hardware_banner_foot {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
}
.Fixed {
  width: 600px;
  height: 380px;
}
.banner_foot_img img {
  width: 600px;
  height: 380px;
}
.hardware_banner_foot .banner_foot_text {
  background: #f8fffe;
  box-shadow: 0px 0px 15px 0px rgba(17, 182, 144, 0.15);
}
.hardware_banner_foot .banner_foot_img {
  box-shadow: 0;
}
.banner_foot_text .foot_text {
  margin-left: 50px;
  margin-right: 50px;
  margin-top: 133px;
  text-align: left;
}
.foot_text i {
  font-size: 30px;
  font-weight: 600;
  color: #11b690;
}
.foot_text p {
  font-size: 16px;
  font-weight: 400;
  color: #333333;
  margin-top: 16px;
} */

/* 客户案例 */
/* .client {
  width: 100%;
  background: #f8f8f8;
}
.client_banner {
  margin: 0 auto;
  width: 1440px;
  padding-top: 50px;
  padding-bottom: 60px;
}
.client_banner_head {
  text-align: center;
}
.client_banner_head i {
  font-size: 30px;
  font-weight: 600;
  color: #333333;
}
.client_banner_head .banner_head_cut {
  width: 60px;
  height: 2px;
  background: #333333;
  margin: 0 auto;
  margin-top: 30px;
}
.client_foot {
  display: flex;
  justify-content: space-between;
  margin-top: 50px;
  text-align: center;
}
.client_foot .client_foot_box {
  background: #ffffff;
  box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.15);
  margin-left: 50px;
  height: 288px;
  float: left;
}
.client_foot .client_foot_box img {
  width: 288px;
  height: 180px;
}
.client_foot .client_foot_box div {
  height: 54px;
  line-height: 54px;
  font-size: 16px;
  font-weight: 600;
  color: #333333;
}
/* 合作伙伴 */
.partner {
  width: 100%;
  background: #f7fbff;
  padding-bottom: 1px;
}

.partner_banner {
  width: 1200px;
  margin: 0 auto;
}

.partner_head {
  font-size: 30px;
  font-weight: 600;
  color: #333333;
  text-align: center;
  padding-top: 60px;
  padding-bottom: 55px;
}

.partner_head .partner_head_cut {
  width: 60px;
  height: 2px;
  background: #333333;
  margin: 0 auto;
  margin-top: 16px;
}

.partner_foot {
  width: 1200px;
  margin: 0 auto;
  display: flex;
  flex-wrap: wrap;
  margin-top: 50px;
  margin-bottom: 60px;
  justify-content:center;
}

.partner_foot img {
  width: 236px;
  height: 180px;
  background: #fff;
}

.partner_foot img:hover {
  transform: scale(1.1, 1.1);
  background: #ffffff;
  box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.1);
  border-radius: 4px;
}

/* 页脚 */
/* .foot {
  width: 100%;
  background: #f5f5f6;
}
.foot_banner {
  width: 1200px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  padding-top: 32px;
  color: #333333;
}
.foot_banner_left img {
  width: 279px;
  height: 66px;
}
.foot_banner_centre p {
  font-size: 16px;
  font-weight: 400;
  margin-left: 5px;
}
.foot_banner_centre i {
  font-size: 22px;
  font-weight: 600;
}
.foot_banner_centre div {
  display: flex;
  flex-wrap: nowrap;
  margin-bottom: 20px;
}
.foot_banner_centre span {
  font-size: 14px;
  font-weight: 400;
  color: #666666;
  margin-top: 13px;
}
.foot_banner_centre img {
  width: 16px;
  height: 16px;
}
.banner_right_h {
  font-size: 22px;
  font-weight: 600;
}
.foot_banner_right div {
  margin-bottom: 10px;
}
.banner_right_f {
  display: flex;
}
.banner_right_h {
  margin-left: 32px;
}
.banner_right_f img {
  width: 120px;
  height: 120px;
  margin-bottom: 5px;
  margin-left: 32px;
}
.banner_right_f div {
  text-align: center;
}
.banner_right_f p {
  margin-left: 32px;
  color: #666666;
} */

/* 免费试用弹窗 */
.shade {
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 3;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}

.register {
  width: 400px;
  height: 408px;
  position: absolute;
  left: 50%;
  top: 50%;
  background: #ffffff;
  border-radius: 4px;
  transform: translateX(-50%) translateY(-50%);
}

.register p {
  text-align: center;
  margin-top: 32px;
  font-size: 20px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #333333;
}

.register .h {
  margin-bottom: 24px;
}

.register .h img {
  width: 24px;
  height: 24px;
  display: inline-block;
  position: absolute;
  right: 12px;
  top: 12px;
  cursor: pointer;
}

.register .h_form {
  width: 300px;
  margin: 0 auto;
}

/* input{
  border: 0;
  outline:none;
  width: 232px;
height: 20px;
font-size: 14px;
font-family: PingFangSC-Regular, PingFang SC;
font-weight: 400;
color: #999999;
} */
.inp {
  width: 300px;
  height: 40px;
  background: #ffffff;
  border-radius: 4px;
  border: 1px solid #d9d9d9;

  margin-top: 16px;
}

.inp .el-input {
  border: 0;
  width: 232px;
}

.inp .el-input .el-input__inner {
  height: 20px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;

  border: 0;
  display: inline-block;
  padding: 0;
}

.inp_ch {
  margin-top: 10px;
  margin-left: 16px;
}

.inp img {
  width: 20px;
  height: 20px;
  vertical-align: bottom;
  margin-right: 16px;
  margin-left: 16px;
  margin-bottom: 10px;
}

.yanzheng {
  width: 103px !important;
}

.vertical {
  display: inline-block;
  width: 3px;
  height: 20px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #d9d9d9;
  line-height: 20px;
  margin-left: 49px;
}

/* .inp .send {
  display: inline-block;
  width: 70px;
  height: 20px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #11b690;
  line-height: 20px;
  border: 0;
  background: #ffffff;
  margin-left: 6px;
  cursor: pointer;
  text-align: center;
} */
.send_count {
  display: inline-block;
  width: 70px;
  height: 20px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #606266;
  line-height: 20px;
  border: 0;
  background: #ffffff;
  margin-left: 6px;

  text-align: center;
}

/* .submit {
  width: 300px;
  height: 40px;
  background: #11b690;
  border-radius: 4px;
  margin: 0 auto;
  margin-top: 32px;
  text-align: center;
  line-height: 40px;
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #ffffff;
  cursor: pointer;
} */

.el-form-item__content {
  margin: 0 !important;
}

.inp_ch {
  margin: 0;
}

.trial {
  padding-bottom: 0;
}

.seamless-warp {
  width: 1440px;
}

.system_apply {
  width: 100%;
  padding-bottom: 48px;
}

.system_box {
  background: #f7fbff;
  width: 100%;
  padding-bottom: 48px;
}

.architecture_box {
  padding-bottom: 48px;
}

.nongpi_box {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.nongpi_box .left_box {
  width: 940px;
  height: 520px;
  background-image: url('../assets/img/nongpi-active.png');
  background-repeat: no-repeat;
  background-size: 100% 100%;
}

.nongpi_box .left_box1 {
  background-image: url('../assets/img/nongmao-active.png');
}

.nongpi_box .left_box2 {
  background-image: url('../assets/img/wuliu-active.png');
}

.architecture_con {
  width: 120px;
  height: 520px;
  font-size: 28px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #ffffff;
  text-align: center;
  padding-top: 167px;
  box-sizing: border-box;
}

.nongpi_box .center_boxs {
  background-image: url('../assets/img/nongmao.png');
  background-repeat: no-repeat;
  background-size: 100% 100%;
}

.nongpi_box .center_boxs1 {
  background-image: url('../assets/img/nongpi.png');
  background-repeat: no-repeat;
  background-size: 100% 100%;
}

.nongpi_box .right_box {
  background-image: url('../assets/img/wuliu.png');
  background-repeat: no-repeat;
  background-size: 100% 100%;
}

.architecture_active_title {
  font-size: 32px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #ffffff;
  margin: 278px 50px 27px;
}

.architecture_active_content {
  width: 555px;
  font-size: 20px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #ffffff;
  margin: 0 50px 32px;
}

.architecture_active_detail {
  font-size: 20px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #5f96f5;
  margin-left: 50px;
}

.architecture_active_detail img {
  width: 16px;
  height: 14px;
}

.architecture_active_detail:hover {
  color: #7ca5f3;
}
</style>
